module.exports = __webpack_public_path__ + "img/yiyanqi.ec9365a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/process/yiyanqi.png
// module id = 520
// module chunks = 137